import { useTranslation } from 'react-i18next';

export type NestedProductCategoryStatus = keyof typeof NESTED_PRODUCT_CATEGORY_STATUS;

export const NESTED_PRODUCT_CATEGORY_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};

export const NESTED_PRODUCT_CATEGORY_IS_MULTI_SELECT = {
    YES: 'YES',
    NO: 'NO',
};

export const useNestedProductCategoryStatus = () => {
    const { t } = useTranslation();
    return {
        ACTIVE: t('STATUS.ACTIVE'),
        INACTIVE: t('STATUS.INACTIVE'),
    };
};

export const useNestedProductIsMultiSelect = () => {
    const { t } = useTranslation();
    return {
        YES: t('STATUS.YES'),
        NO: t('STATUS.NO'),
    };
};

export const NESTED_PRODUCT_CATEGORY_STATUS_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    ACTIVE: 'success',
    INACTIVE: 'error',
};

export const NESTED_PRODUCT_CATEGORY_IS_MULIT_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    YES: 'success',
    NO: 'error',
};

export const useFilterSelectStatusOptions = () => {
    const productCategoryStatus = useNestedProductCategoryStatus();

    return Object.keys(productCategoryStatus).map((status) => ({
        value: status,
        label: productCategoryStatus[status],
    }));
};

export const useFilterSelectIsMultiSelectOptions = () => {
    const productCategoryStatus = useNestedProductIsMultiSelect();

    return Object.keys(productCategoryStatus).map((status) => ({
        value: status,
        label: productCategoryStatus[status],
    }));
};
